export default "__VITE_ASSET__0640829f__"